// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../node_modules/@daypicker/react/dist/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --money-color: var(--color-green-700);
  --accent-color: var(--color-red-600);
  --transparent-accent-color: var(--color-red-50);
  --border-color: var(--color-gray-200);
  --background-color: var(--color-gray-50);
  --small-border-radius: var(--radius-md);
  --large-border-radius: var(--radius-xl);
  --link-color: var(--color-blue-500);
  --scroll-width: 10px;
  --hover-color: var(--color-neutral-100);
  --active-color: var(--color-neutral-200);
  font-family: Roboto;
}

* {
  box-sizing: border-box;
}

*::-webkit-scrollbar {
  width: var(--scroll-width);
  height: var(--scroll-width);
}

*::-webkit-scrollbar-thumb {
  background-color: var(--color-neutral-300);
  border-radius: 8px;
  border: 3px solid transparent;
  background-clip: padding-box;
}

a {
  color: var(--link-color);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.rdp-root {
  --rdp-caption-font-size: 15px;
  --rdp-accent-color: var(--color-red-500);
  --rdp-accent-background-color: var(--color-red-50);
  --rdp-day-width: 34px;
  --rdp-day-height: 34px;
  --rdp-day_button-width: 100%;
  --rdp-day_button-height: 100%;
  --rdp-nav-height: 36px;
}

.rdp-months {
  gap: 16px;
}

.rdp-month_caption {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-neutral-800);
}

.rdp-chevron {
  width: 20px;
  height: 20px;
  fill: var(--color-neutral-700);
}

.rdp-month_grid {
  border-spacing: 0px 6px;
  border-collapse: separate;
}

.rdp-week {
  border-top: 4px solid white;
  border-bottom: 4px solid white;
  border-spacing: 0px;
}

.rdp-weekday {
  text-transform: capitalize;
}

.rdp-day {
  color: var(--color-neutral-800);
  font-size: 15px;
  border: none;
  padding: 0px;
}

.rdp-outside, .rdp-outside.rdp-selected {
  color: var(--color-neutral-500);
}

.rdp-outside.rdp-selected {
  opacity: 1;
}

.rdp-day:nth-child(1 of :not(.rdp-hidden)) {
  border-end-start-radius: var(--radius-4xl);
  border-start-start-radius: var(--radius-4xl);
}

.rdp-day:nth-last-child(1 of :not(.rdp-hidden)) {
  border-end-end-radius: var(--radius-4xl);
  border-start-end-radius: var(--radius-4xl);
}

.rdp-selected {
  color: var(--color-black);
  font-weight: normal;
}

.rdp-month_caption .rdp-dropdowns {
  text-transform: capitalize;
}

.rdp-caption_label {
  gap: 2px;
}

.rdp-caption_label .rdp-chevron {
  width: 18px;
  height: 18px;
}

.rdp-dropdown:focus-visible ~ .rdp-caption_label {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./../core/src/theme.css"],"names":[],"mappings":"AAIA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,oBAAoB;EACpB,uCAAuC;EACvC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,kDAAkD;EAClD,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n@import '@daypicker/react/style.css';\n@import './variables.css';\n\n:root {\n  --money-color: var(--color-green-700);\n  --accent-color: var(--color-red-600);\n  --transparent-accent-color: var(--color-red-50);\n  --border-color: var(--color-gray-200);\n  --background-color: var(--color-gray-50);\n  --small-border-radius: var(--radius-md);\n  --large-border-radius: var(--radius-xl);\n  --link-color: var(--color-blue-500);\n  --scroll-width: 10px;\n  --hover-color: var(--color-neutral-100);\n  --active-color: var(--color-neutral-200);\n  font-family: Roboto;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n*::-webkit-scrollbar {\n  width: var(--scroll-width);\n  height: var(--scroll-width);\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-300);\n  border-radius: 8px;\n  border: 3px solid transparent;\n  background-clip: padding-box;\n}\n\na {\n  color: var(--link-color);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.rdp-root {\n  --rdp-caption-font-size: 15px;\n  --rdp-accent-color: var(--color-red-500);\n  --rdp-accent-background-color: var(--color-red-50);\n  --rdp-day-width: 34px;\n  --rdp-day-height: 34px;\n  --rdp-day_button-width: 100%;\n  --rdp-day_button-height: 100%;\n  --rdp-nav-height: 36px;\n}\n\n.rdp-months {\n  gap: 16px;\n}\n\n.rdp-month_caption {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--color-neutral-800);\n}\n\n.rdp-chevron {\n  width: 20px;\n  height: 20px;\n  fill: var(--color-neutral-700);\n}\n\n.rdp-month_grid {\n  border-spacing: 0px 6px;\n  border-collapse: separate;\n}\n\n.rdp-week {\n  border-top: 4px solid white;\n  border-bottom: 4px solid white;\n  border-spacing: 0px;\n}\n\n.rdp-weekday {\n  text-transform: capitalize;\n}\n\n.rdp-day {\n  color: var(--color-neutral-800);\n  font-size: 15px;\n  border: none;\n  padding: 0px;\n}\n\n.rdp-outside, .rdp-outside.rdp-selected {\n  color: var(--color-neutral-500);\n}\n\n.rdp-outside.rdp-selected {\n  opacity: 1;\n}\n\n.rdp-day:nth-child(1 of :not(.rdp-hidden)) {\n  border-end-start-radius: var(--radius-4xl);\n  border-start-start-radius: var(--radius-4xl);\n}\n\n.rdp-day:nth-last-child(1 of :not(.rdp-hidden)) {\n  border-end-end-radius: var(--radius-4xl);\n  border-start-end-radius: var(--radius-4xl);\n}\n\n.rdp-selected {\n  color: var(--color-black);\n  font-weight: normal;\n}\n\n.rdp-month_caption .rdp-dropdowns {\n  text-transform: capitalize;\n}\n\n.rdp-caption_label {\n  gap: 2px;\n}\n\n.rdp-caption_label .rdp-chevron {\n  width: 18px;\n  height: 18px;\n}\n\n.rdp-dropdown:focus-visible ~ .rdp-caption_label {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
